const getPrompt = async (botId) => {
  const serverDomain = process.env.REACT_APP_SERVER;
  const url = `${serverDomain}/bot/prompt/${botId}`;

  const option = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await fetch(url, option);

    if (!res.ok) {
      return {
        data: "You are a helpful and friendly assistant whose job is to faithfully answer the question based on the context below. You are serving as a helper to visitors to a website who could be potential customers for the business.",
        error: true,
        msg: "Failed to update prompt. Please try again.",
      };
    }

    const data = await res.json();
    return {
      data: data?.data,
      error: false,
      msg: "Prompt updated successfully.",
    };
  } catch (err) {
    return {
      data: "You are a helpful and friendly assistant whose job is to faithfully answer the question based on the context below. You are serving as a helper to visitors to a website who could be potential customers for the business.",
      error: true,
      msg: "Server error. Please check your connection and try again.",
    };
  }
};

export default getPrompt;
